import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ApiService from '../../services/ApiService';
import ModalContext from './ModalContext';
import ModalWrapper from './ModalWrapper';
import ChangeBranch from './ChangeBranch';
import DrilldownContainer from './DrilldownContainer';
import TimeClock from '../timeclock/TimeClock';

import ModalAttachments from './ModalAttachments';
import ModalCollection from './ModalCollection';
import ModalCustomerDetail from './ModalCustomerDetail';
import ModalDetail from './ModalDetail';
import ModalLegacy from './ModalLegacy';
import ModalListContainer from './ModalListContainer';
import ModalPartCalculation from './ModalPartCalculation';
import ModalPartPriceCheck from './ModalPartPriceCheck';
import ModalRepairNotes from './ModalRepairNotes';
import ModalRepairStory from './ModalRepairStory';
import ModalTableContainer from './ModalTableContainer';
import ModalUploadImage from './ModalUploadImage';

import LinkAttachment from './LinkAttachment';
import ViewInvoice from './ViewInvoice';

import Loyalty, { CustomerSearch, CustomerUpdate, Offer, OfferList, RedemptionList } from '../loyalty';

import CustomerHistoryAR from './CustomerHistoryAR';
import CustomerHistoryParts from './CustomerHistoryParts';
import DocumentEmail from '../signature/DocumentEmail';
import PartDetail from './PartDetail';
import EstimateHistory from './EstimateHistory';
import RepairHistory from './RepairHistory';
import VehicleOperations from './VehicleOperations';
import VehicleSpecSheet from './VehicleSpecSheet';
import VendorInformation from './VendorInformation';
import PrintPurchaseOrder from './PrintPurchaseOrder';
import PrintRepairOrder from './PrintRepairOrder';
import ListEditContainer from '../list/ListEditContainer';
import DbEditContainer from '../db/DbEditContainer';
import ItemEditContainer from '../item/ItemEditContainer';
import PageLockedDialog from './PageLockedDialog';
import QuoteCostToDate from '../crm/QuoteCostToDate';
import QuickCreate from '../crm/QuickCreate';
import CopyQuote from '../crm/CopyQuote';
import CreateSimilarQuote from '../crm/CreateSimilarQuote';
import { EE, modal } from './ModalEmitter';

class ModalConductor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modals: [],
      configs: {}, // TODO probably should be a prop loaded in
    };

    this.close = this.close.bind(this);
    this.ok = this.ok.bind(this);
    this.setTitle = this.setTitle.bind(this);
    this.addModal = this.addModal.bind(this);

    this.ModalContext = {
      hasContext: true,
      close: this.close,
      ok: this.ok,
    };
  }

  componentDidMount() {
    EE.on('modal/open', (type, args) => {
      this.addModal(type, { ...args });
    });

    EE.on('modal/confirm', args => {
      this.addModal('confirm', { ...args });
    });

    EE.on('modal/alert', args => {
      this.addModal('alert', { ...args });
    });

    EE.on('modal/info', args => {
      this.addModal('info', { ...args });
    });

    EE.on('modal/close', args => {
      this.close(args);
    });

    EE.on('modal/closeAll', () => {
      this.closeAll();
    });

    ApiService.get('/drilldown/views').then(response => {
      // TODO Hacky part 2
      const configs = response.data;
      this.setState({ configs });
      modal.config = configs;
    });
  }

  componentWillUnmount() {
    EE.removeListener('modal/open');
    EE.removeListener('modal/confirm');
    EE.removeListener('modal/alert');
    EE.removeListener('modal/info');
    EE.removeListener('modal/close');
    EE.removeListener('modal/closeAll');
  }

  setTitle(which, title) {
    const modals = this.state.modals;

    // Sometimes modals can get closed/opened too quickly
    // so check for existence first
    if (modals[which] && modals[which].options) {
      if (typeof title === 'function') {
        modals[which].options.title = title();
      } else {
        modals[which].options.title = title;
      }

      this.setState({ modals });
    }
  }

  ok(payload = {}) {
    const { modals } = this.state;
    const lastModal = _.findLast(modals, m => !m.closing);

    // Don't close modal if precheck exists and returns false
    if (lastModal.options && lastModal.options.precheck) {
      if (!lastModal.options.precheck()) {
        return;
      }
    }

    this.close({ skipOnClose: true });

    if (lastModal.options && lastModal.options.callback) {
      lastModal.options.callback(payload);
    }
  }

  close(params = {}) {
    const { modals } = this.state;
    const lastModal = _.findLast(modals, m => !m.closing);

    const callback = () => {
      setTimeout(() => {
        const newModals = _.filter(this.state.modals, m => m.closing !== true);
        modal.isOpen = !!newModals.length;
        this.setState({ modals: newModals });
      }, 300);
    };

    if (lastModal) {
      const updatedModals = modals.map(m => {
        if (m.id === lastModal.id) {
          return { ...m, closing: true };
        }

        return { ...m };
      });

      // TODO modal.close won't have updated state, so mutating to keep it working as expected
      lastModal.closing = true;

      if (!params.skipOnClose) {
        if (lastModal.options && lastModal.options.onClose) {
          lastModal.options.onClose(params);
        }
      }

      this.setState({ modals: updatedModals }, callback);
    }
  }

  closeAll() {
    const { modals } = this.state;
    const callbacks = [];

    modals.forEach(modal => {
      callbacks.unshift(() => {
        if (modal && modal.options && modal.options.onClose) {
          modal.options.onClose();
        }
      });
    });

    modal.isOpen = false;
    this.setState(
      { modals: [] },
      callbacks.forEach(cb => cb())
    );
  }

  addModal(view, options = {}, callbacks = {}) {
    const { modals, configs } = this.state;
    const lastModal = modals[modals.length - 1] || {};

    if (!view) {
      return null;
    }

    options.view = view;

    if (configs[view]) {
      [
        'title',
        'render',
        'headerClass',
        'dialogClass',
        'icon',
        'hideFooter',
        'hidePrint',
        'style',
        'size',
        'confirm',
        'confirmLabels',
        'staticBackdrop',
      ].forEach(key => {
        if (configs[view][key] && options[key] === undefined) {
          options[key] = configs[view][key];
        }
      });
    }

    if (!options.render) {
      options.render = options.view;
    }

    const newModal = {
      view: options.view || view,
      title: options.title || options.view || view,
      options,
      callbacks,
      id: options.id || Math.random().toString(36),
    };

    if (newModal && newModal.options && newModal.options.lookupKey) {
      newModal.title = `${newModal.title} (${newModal.options.lookupKey})`;
    }

    // Ensure the same modal doesn't get pushed into state
    if (newModal.id !== lastModal.id) {
      modals.push(newModal);
      this.setState({ modals }); // eslint-disable-line
    }

    modal.isOpen = !!modals.length;
    return newModal;
  }

  renderModalBody(modal, index) {
    const view = modal.view;
    const options = modal.options;

    switch (options.render) {
      // Plugs html responses into a modal
      case 'linkAttachment':
        return <LinkAttachment {...options} />;

      case 'drilldown':
        return <DrilldownContainer lookupKey={options.lookupKey} drilldown={view} />;

      case 'uploadImage':
        return <ModalUploadImage {...options} />;

      case 'attachments': {
        // Context of helper modal
        if (options.lookupKey && !options.itemId) {
          options.itemId = options.lookupKey;
        }

        if (!options.itemName && options.contextName) {
          options.itemName = options.contextName;
        }

        return <ModalAttachments {...options} />;
      }

      // Handles terminal output
      case 'legacy':
        return <ModalLegacy {...options} />;

      // Handles a single table modal
      case 'table':
        return <ModalTableContainer {...options} />;

      case 'customerDetail':
      case 'customerRepairOrderDetail':
        return <ModalCustomerDetail {...options} />;

      case 'customerHistoryAR':
        return <CustomerHistoryAR {...options} />;

      case 'customerHistoryParts':
        return <CustomerHistoryParts {...options} />;

      case 'estimateHistory':
        return <EstimateHistory {...options} />;

      case 'partDetail':
        return <PartDetail {...options} />;

      case 'repairHistory':
        return <RepairHistory {...options} />;

      case 'vehicleSpecSheet':
        return <VehicleSpecSheet {...options} />;

      case 'vendorInformation':
        return <VendorInformation {...options} />;

      case 'quoteCostToDate':
        return <QuoteCostToDate {...options} />;

      case 'quickCreate':
        return <QuickCreate {...options} />;

      case 'copyQuote':
        return <CopyQuote {...options} />;

      case 'createSimilarQuote':
        return <CreateSimilarQuote {...options} />;

      // Handles a single list modal
      case 'list':
        return <ModalListContainer {...options} />;

      case 'detail':
        return (
          <ModalDetail
            view={view}
            lookupKey={options.lookupKey}
            branchId={options.branchId}
            setTitle={title => this.setTitle(index, `${modal.options.title} (${title})`)}
          />
        );

      case 'dbEditItem':
        return (
          <DbEditContainer
            action={options.action}
            itemId={options.lookupKey}
            itemName={options.itemName}
            onCancel={this.close}
            submitCallback={response => {
              if (options.submitCallback) {
                options.submitCallback(response);
              }
              this.close();
            }}
            persistTabs={false}
            usePrefix="modal"
            query={options.query}
          />
        );

      case 'listEditItem':
        return (
          <ListEditContainer
            action={options.action}
            branchId={options.branchId}
            itemId={options.lookupKey}
            itemName={options.itemName}
            handleCancel={this.close}
            submitCallback={response => {
              if (options.submitCallback) {
                options.submitCallback(response);
              }
              this.close();
            }}
            persistTabs={false}
            usePrefix="modal"
            query={options.query}
            readOnly={options.readOnly}
          />
        );

      case 'editItem':
        return (
          <ItemEditContainer
            branchId={options.branchId}
            itemId={options.lookupKey}
            itemName={options.itemName}
            handleCancel={this.close}
            submitCallback={response => {
              if (options.submitCallback) {
                options.submitCallback(response);
              }
              this.close();
            }}
            persistTabs={false}
            usePrefix="modal"
            query={options.query}
          />
        );

      case 'timeclock':
        return <TimeClock {...options} />;

      case 'pageLocked':
        return <PageLockedDialog {...options} />;

      case 'collection':
        return <ModalCollection {...options} />;

      case 'repairNotes':
        return <ModalRepairNotes {...options} />;

      case 'repairStories':
        return <ModalRepairStory {...options} />;

      case 'partPriceCheck':
        return <ModalPartPriceCheck {...options} />;

      case 'partCalculation':
        return (
          <ModalPartCalculation
            lookupKey={options.lookupKey}
            setTitle={title => this.setTitle(index, title)}
            close={this.close}
          />
        );

      case 'printPurchaseOrder':
        return (
          <PrintPurchaseOrder
            close={this.close}
            purchaseOrderId={options.lookupKey}
            formHandler={options.fec}
            setTitle={title => this.setTitle(index, title)}
          />
        );

      case 'printRepairOrder':
        return (
          <PrintRepairOrder
            close={this.close}
            repairOrderId={options.lookupKey}
            formHandler={options.fec}
            setTitle={title => this.setTitle(index, title)}
          />
        );

      case 'vehicleOperations':
        return (
          <VehicleOperations
            vin={options.lookupKey}
            rowId={options.rowId}
            dataIndex={options.dataIndex}
            formHandler={options.fec}
            close={this.close}
          />
        );

      case 'viewInvoice':
        return (
          <ViewInvoice setTitle={title => this.setTitle(index, `${modal.options.title} (${title})`)} {...options} />
        );

      case 'changeBranch':
        return <ChangeBranch branches={options.branches} />;

      case 'loyaltyCustomerSearch':
        return (
          <Loyalty>
            <CustomerSearch {...options} />
          </Loyalty>
        );

      case 'loyaltyCustomerUpdate':
        return (
          <Loyalty>
            <CustomerUpdate {...options} />
          </Loyalty>
        );

      case 'loyaltyOffer':
        return (
          <Loyalty>
            <Offer {...options} />
          </Loyalty>
        );

      case 'loyaltyOffers':
        return (
          <Loyalty>
            <OfferList {...options} />
          </Loyalty>
        );

      case 'loyaltyRedemptions':
        return (
          <Loyalty>
            <RedemptionList {...options} />
          </Loyalty>
        );

      case 'emailDocument':
        return <DocumentEmail {...options} />;

      case 'alert':
      case 'confirm':
      case 'info':
      default:
        return options.message;
    }
  }

  render() {
    const modals = [];

    this.state.modals.forEach((modal, index) => {
      const nextModal = this.state.modals[index + 1];
      const topIsClosing = nextModal && nextModal.closing;

      modals.push(
        <ModalContext.Provider
          // key={`${modal.view}-${index}`}
          key={modal.id}
          value={{
            ...this.ModalContext,
            modalId: index,
            setTitle: t => {
              this.setTitle(index, t);
            },
            options: modal.options,
            print: () => {
              window.print();
            },
          }}
        >
          <ModalWrapper
            key={modal.view}
            close={this.close}
            confirm={modal.options.render === 'confirm' || modal.options.confirm}
            ok={this.ok}
            print={this.print}
            show={!modal.closing}
            topModal={this.state.modals.length === index + 1}
            view={modal.view}
            topIsClosing={topIsClosing}
            {...modal.options}
          >
            {this.renderModalBody(modal, index)}
          </ModalWrapper>
        </ModalContext.Provider>
      );
    });

    return <div id="modal-conductor">{modals}</div>;
  }
}

ModalConductor.propTypes = {
  users: PropTypes.array,
};

export default ModalConductor;
